import { OptimizeResponse } from '@dispatch/shared/types';
import { dispatchClient } from '../clients';

const OPTIMIZE_TASK_URL = '/availability/optimize';

export async function optimizeTasksByType(data: { taskTypes: string[] }) {
  return dispatchClient
    .post<OptimizeResponse>(
      `${OPTIMIZE_TASK_URL}`,
      {},
      {
        params: {
          taskTypes: data.taskTypes.toString(),
        },
      }
    )
    .then((response) => {
      // we are only expecting a 204 or 429 response
      // 204 means the optimization was started
      // 429 means the optimization is already running
      // any other response is an error

      if (response.status === 200 || response.status === 429) {
        return response.data;
      }

      throw new Error(
        `Error optimizing tasks.  Response status: ${response.status}`
      );
    });
}
